import { CourseTreeNodeTypeEnum } from "@/types/generated";
import type { CourseTreeNode } from "@/types/generated";

/** Share of the course a learner has to finish before the final quiz opens up. */
export const COURSE_FINAL_QUIZ_UNLOCK_PERCENT = 90;

export const isCourseFinalQuizUnlocked = (
  hasEnrollment: boolean,
  progressPercent: number
): boolean =>
  hasEnrollment && progressPercent >= COURSE_FINAL_QUIZ_UNLOCK_PERCENT;

interface IndexedNode {
  node: CourseTreeNode;
  contentElements?: CourseTreeNode[];
}

/**
 * Number of questions in the course's final quiz subchapter, or null when the
 * course has none.
 */
export const findCourseFinalQuizQuestionCount = (
  nodeIndex: Map<string, IndexedNode>
): number | null => {
  for (const entry of nodeIndex.values()) {
    if (
      entry.node.type === CourseTreeNodeTypeEnum.Subchapter &&
      entry.node.courseCompletionQuiz
    ) {
      return entry.contentElements?.length ?? 0;
    }
  }
  return null;
};

/**
 * A chapter's subchapters as the regular tree shows them: the course final
 * quiz is reached through its own entry instead. The flag lives on the parsed
 * nodes in `nodeIndex`; the raw structure nodes a chapter holds don't carry it.
 */
export const getRegularSubchapters = (
  chapter: CourseTreeNode,
  nodeIndex: Map<string, IndexedNode>
): CourseTreeNode[] =>
  (chapter.children ?? []).filter(
    (child) =>
      child.type === CourseTreeNodeTypeEnum.Subchapter &&
      !nodeIndex.get(child.id)?.node.courseCompletionQuiz
  );
